import Jobs from "~/services/jobs";
import { ScheduleJob } from "~/types/jobs";
import api from "~/adapters/api";

type ResponseStatus = "ok" | "error";

export type Response = {
    responseStatus: ResponseStatus;
    errorDescription?: string;
    data?: {
        fields: Partial<ScheduleJob>;
        schedulingConfig: {
            schedulingTimeCalculation: any;
            defaultSegment: any;
            contactIsUser: any;
            defaultSchedulingType: any;
            defaultBriefing: any;
            doNotShowInPlaceContactInfo: any;
            doNotShowCustomerCode: any;
        };
    };
};

export function fetchScheduleConfig(token: string): Promise<Response> {
    return Jobs.view(token)
        .then((res) => res.data)
        .then((res) => {
            const [jobDetail] = res.jobDetails;
            const JobsInSamePlace = res?.jobsInSamePlace || []
            if (!jobDetail) {
                return null;
            }

            const data: Partial<ScheduleJob> = {
                id: jobDetail.id_jobs,
                status: jobDetail.job_status,
                userId: jobDetail.id_clientes,
                briefingId: jobDetail.id_customer_briefing,
                organizationId: jobDetail.id_organization,
                contactName: jobDetail.contactName,
                segmentId: jobDetail.id_segment,
                contactPhone: jobDetail.contact_mobile,
                contactEmail: jobDetail.contact_email,
                inPlaceContactName: jobDetail.contact_name_local,
                inPlaceContactPhone: jobDetail.contact_mobile_local,
                inPlaceContactEmail: jobDetail.contact_email_local,
                scheduleDate: jobDetail?.job_date ? `${jobDetail.job_date}T${jobDetail.job_hour}:00.000-0300` : null,
                period: jobDetail?.period,
                address: jobDetail.address,
                number: jobDetail.number,
                neighborhood: jobDetail.neighborhood,
                complement: jobDetail.complement,
                customerCode: jobDetail.internal_code_customer,
                type: "business",
                observation: jobDetail.obs,
                cityName: jobDetail.city,
                uf: jobDetail.uf,
                region: jobDetail.region,
                jobsInSamePlace: JobsInSamePlace,
                jobIdGrouping: jobDetail?.jobIdGrouping,
                extra: {
                    metragem: {
                        name: "metragem",
                        contextId: null,
                        type: "numero",
                        value: res?.extra?.metragem?.value,
                    },
                },
                logoUrl: jobDetail.logoUrl
            };

            return data;
        })
        .then(async (data: Partial<ScheduleJob> | undefined) => {
            if (!data) {
                return { responseStatus: "error" as ResponseStatus, errorDescription: "Não foi possível encontrar o job" };
            }

            return api.organizations.schedulingConfig
                .get({ organizationId: data.organizationId, segmentId: data.segmentId, token })
                .then(async (config) => {
                    return {
                        responseStatus: "ok" as ResponseStatus,
                        data: {
                            fields: data,
                            schedulingConfig: {
                                schedulingTimeCalculation: config.schedulingTimeCalculation,
                                defaultSegment: config.defaultSegment,
                                contactIsUser: config.contactIsUser,
                                defaultSchedulingType: config.defaultSchedulingType,
                                defaultBriefing: config.defaultBriefing,
                                doNotShowInPlaceContactInfo: config.doNotShowInPlaceContactInfo,
                                doNotShowCustomerCode: config.doNotShowCustomerCode,
                            }
                        }
                    };
                });
        })
        .catch(e => {
            return {
                responseStatus: "error" as ResponseStatus,
                errorDescription: `Ocorreu um erro inesperado ao recuperar os dados do agendamento: ${e.message}`
            };
        });
}
